
function ShowHideButtons( fillOutSubmission ){
	var me = this;
	var $ = fillOutSubmission.$;
	me.fillOutSubmission = fillOutSubmission;

	me.hidePreviousOnFirstPage = function(){
		var previousPage = me.fillOutSubmission.getPreviousPage();
		$('.previousPage').css('display' ,
			(  ! previousPage.length ? 'none'  : 'block'  ) );
	}

	me.showHide = function(){
		var currentPage = me.fillOutSubmission.getCurrentPage();
		var nextPage = me.fillOutSubmission.getNextPage();

		var isLastPage = !nextPage.length;
		var currentPageId = me.fillOutSubmission.getCurrentPageId();
		var wantsToBeAnonymous = me.fillOutSubmission.wantsToBeAnonymous() ;
	
		me.hidePreviousOnFirstPage();

		// SUBMIT BUTTON SHOWING? maybe not all view files are loaded
	
		if( currentPageId == 'enterAnonymousDecision'  ){

			me.ananonymousDecision( wantsToBeAnonymous );

		} else if( currentPageId == 'enterPersonalData' ){

			me.personalData();
			
		} else {

			me.defaultAction( isLastPage, currentPageId );
		}	
	};

	me.defaultAction = function( isLastPage, currentPageId ){

		$('.nextPage').css('display' ,
			(  isLastPage  ? 'none'  : 'block'  ) );			
		$('.submit').css('display' ,
			(  isLastPage ? 'block'  : 'none'  ) );

	};

	me.personalData = function(){

		$('.submit').css('display', 'block' );
		$('.nextPage').css('display', 'none' );
		// $('.buttonBar').css('width', '110%');
	};

	me.ananonymousDecision = function( wantsToBeAnonymous ){
		// debugger
		var showNextPage = wantsToBeAnonymous === '0' || typeof wantsToBeAnonymous == 'undefined';
		var showSubmit = wantsToBeAnonymous === '1' ;

		$('.submit').css('display' , 
			( showSubmit ? 'block' : 'none' ));
		$('.nextPage').css('display' ,
			( showNextPage  ? 'block'  : 'none'  ) );
		// $('.buttonBar').css('width', '110%');
	};

	me.showHide();
}